import { FC } from 'react'
import * as styles from 'styles/atoms/tables/TableNoWrapValue.css'

type TableNoWrapValueProps = {
  text?: string
}

const TableNoWrapValue: FC<TableNoWrapValueProps> = (props) => {
  const { text, children } = props
  return (
    <div className={ styles.tableNoWrapValue }>{ text || children }</div>
  )
}

export default TableNoWrapValue
